import React  from "react";
import classNames from 'classnames';
import rawHtml  from 'html-react-parser';
import TaskImg from "~/assets/images/task/task.png"

import CheckMark from "../CheckMark";


const AvailableTaskCard = ({item, setSelectedTask, setOverlayOpen})=> {
  return (
    <div key={item.id} onClick={()=>{ setSelectedTask(item); setOverlayOpen(true); }}
      className={classNames("item", {new: new Date().setHours(0,0,0,0) === new Date(item.createdAt).setHours(0,0,0,0) } )}>
      <CheckMark task={item} />
      <div className="short-description">
        <h5> {item.title} </h5>
        { rawHtml(item.shortDescription || '') }
        <p> <small>Points: { item.points } </small> </p>
      </div>
      <img src={item.icon || TaskImg} className="b-r-10" style={{ width: 50 }} />
    </div>
  );
};

export default AvailableTaskCard;
